import React from 'react'
import { Card, Table, Pagination } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getUserRoomViewListAPI } from '@/apis/user'
const { Column } = Table
//import Dayjs from 'dayjs'

export default function RoomList() {
  const location = useParams()
  const userId = location.userid
  const tabList = [30, 90, 180]
  const [tabIndex, setTabIndex] = useState(0)
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  const [listQuery, setListQuery] = useState({
    userId,
    days: tabList[tabIndex],
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  楼盘总数
  const [list, setList] = useState(0) //  楼盘列表

  //  楼盘列表
  const fetchData = async () => {
    setListLoading(true)
    const res = await getUserRoomViewListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.area = Math.round(item.area)
          item.price = Math.round(item.price)
          item.totalPrice = Math.round(item.totalPrice)
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  //  切换
  const changeTabs = index => {
    if (index == tabIndex) {
      return false
    }
    setTabIndex(index)
    listQuery.days = tabList[index]
    listQuery.pageInt = 1
    setListQuery(listQuery)
    fetchData()
  }
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div>
      <Card className="card">
        <div className="card-title">
          <div className="card-txt">房源偏好</div>
          <div className="housedetail-signtabs">
            {tabList.map((item, index) => {
              return (
                <div className={index == tabIndex ? 'housedetail-signtabs-item housedetail-signtabs-item-active' : 'housedetail-signtabs-item'} key={index} onClick={() => changeTabs(index)}>
                  {item} 天
                </div>
              )
            })}
          </div>
        </div>
        <Table dataSource={list} loading={listLoading} pagination={false} rowKey="key">
          <Column title="所属楼盘" dataIndex="houseName" />
          <Column title="预售证" dataIndex="evidenceName" />
          <Column title="楼栋" dataIndex="shortName" />
          <Column title="单元" dataIndex="unitName" />
          <Column title="楼层" dataIndex="floor" />
          <Column title="房号" dataIndex="name" />
          <Column title="面积" dataIndex="area" />
          <Column title="单价" dataIndex="price" />
          <Column title="总价" dataIndex="totalPrice" />
          <Column title="交付标准" dataIndex="delivery" />
          <Column title="状态" dataIndex="saleStatus2" />
          <Column title="有效访问次数" dataIndex="quarterVisitorNum" />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
